import { useCallback } from "react";

import usePageData from "@hooks/usePageData";
import { useTokenHolders, useStaderTVL } from "dapp-sdk-v2";

import PlatformCard from "@components/PlatformCard";
import { convertNumberToStringRepresentation } from "@utils/globalCommon";

import { iconMapping } from "icons";

const Platform = () => {
  const platformData =
    usePageData(
      "$.page.data.right_sections.data[?(@.attributes.key=='platform')]"
    )[0]?.attributes || {};

  const staderTVL = useStaderTVL();
  const tokenHolders = useTokenHolders();

  const getPlatformSection = useCallback(
    (key: string = "") => {
      if (key === "staderTVL") {
        return staderTVL
          ? `$${convertNumberToStringRepresentation(staderTVL)} +`
          : "-";
      } else if (key === "holdersData") {
        return tokenHolders
          ? `${convertNumberToStringRepresentation(tokenHolders.toString())} +`
          : "-";
      }
      return "-";
    },
    [staderTVL, tokenHolders]
  );

  const getPlatFormData = useCallback(
    (data: any) => {
      return data.map((item: any) => {
        return {
          icon: iconMapping(item.img_key),
          title: item.title,
          value: item?.description
            ? item.description
            : getPlatformSection(item?.key),
        };
      });
    },
    [getPlatformSection]
  );

  return (
    <PlatformCard
      title={platformData.title}
      platformData={getPlatFormData(platformData?.content?.[0]?.data) || []}
    />
  );
};

export default Platform;
